// Librerias
import React from 'react'
let PropTypes = React.PropTypes
import { AutoSizer, Table, Column } from 'react-virtualized'
// Componentes
import { HeaderConBusqueda } from '../../components/shared/HeaderConBusqueda.jsx'
import { ModalConfirmar, ModalTrigger } from './Modales.jsx'
// Styles
import * as css from './TablaPendientes.css'
import classNames from 'classnames/bind'
let cx = classNames.bind(css)

export class TablaPendientes extends React.Component {
    render() {
        return (
            <div style={{ height: '50%', alignItems: 'center' }}>
                <AutoSizer>
                    {({ height, width }) =>
                        <Table
                            // general
                            height={height}
                            width={width}
                            // headers
                            headerHeight={30}
                            headerClassName={css.headerColumn}
                            // rows
                            rowCount={this.props.usuarios.length}
                            rowGetter={({ index }) => this.props.usuarios[index]}
                            rowHeight={40}
                            rowClassName={({ index }) => index < 0 ? css.headerRow : ((index % 2 === 0) ? css.evenRow : css.oddRow)}
                        >
                            <Column
                                dataKey='#'
                                label={'#'}
                                disableSort={true}
                                cellRenderer={({ rowIndex }) => rowIndex + 1}
                                width={30}
                            />
                            <Column
                                dataKey='RUN'
                                label={'RUN'}
                                cellRenderer={({ rowData, dataKey }) => rowData[dataKey]}
                                headerRenderer={() =>
                                    <HeaderConBusqueda
                                        nombre="RUN"
                                        busqueda={this.props.busquedaRUN}
                                        realizarBusqueda={this.props.realizarBusquedaRUN}
                                    />
                                }
                                width={80}
                            />
                            <Column
                                dataKey='nombres'
                                label={'nombres'}
                                headerRenderer={() =>
                                    <HeaderConBusqueda
                                        nombre="Nombres"
                                        busqueda={this.props.busquedaNombre}
                                        realizarBusqueda={this.props.realizarBusquedaNombre}
                                    />
                                }
                                cellRenderer={({ rowData }) =>
                                    <div>
                                        <p style={{ margin: 0 }}>{rowData.nombre1}</p>
                                        <p style={{ margin: 0 }}>{rowData.nombre2}</p>
                                    </div>
                                }
                                width={140}
                            />
                            <Column
                                dataKey='apellidos'
                                label={'Apellidos'}
                                headerRenderer={() =>
                                    <HeaderConBusqueda
                                        nombre="Apellidos"
                                        busqueda={this.props.busquedaApellido}
                                        realizarBusqueda={this.props.realizarBusquedaApellido}
                                    />
                                }
                                cellRenderer={({ rowData }) =>
                                    <div>
                                        <p style={{ margin: 0 }}>{rowData.apellidoPaterno}</p>
                                        <p style={{ margin: 0 }}>{rowData.apellidoMaterno}</p>
                                    </div>
                                }
                                width={140}
                            />
                            <Column
                                dataKey='comuna'
                                label={'Comuna'}
                                headerRenderer={() =>
                                    <HeaderConBusqueda
                                        nombre="Comunas"
                                        busqueda={this.props.busquedaComuna}
                                        realizarBusqueda={this.props.realizarBusquedaComuna}
                                    />
                                }
                                cellRenderer={({ dataKey, rowData }) => rowData[dataKey]}
                                width={100}
                            />
                            <Column
                                dataKey='captador'
                                label={'Captador'}
                                headerRenderer={() =>
                                    <HeaderConBusqueda
                                        nombre="Captador"
                                        busqueda={this.props.busquedaCaptador}
                                        realizarBusqueda={this.props.realizarBusquedaCaptador}
                                    />
                                }
                                cellRenderer={({ dataKey, rowData }) => rowData[dataKey]}
                                width={100}
                            />
                            <Column
                                dataKey=''
                                label={''}
                                cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => (
                                    <div style={{ marginLeft: '20px' }}>
                                        {//console.log(rowData)
                                        }
                                        <BotonAprobar
                                            usuario={{ rowData }}
                                            confirmar={this.props.confirmarOperador}
                                            fetchUsuarios={this.props.fetchUsuarios}
                                        />
                                        <button className='btn btn-danger' title="Rechazar operador">
                                            <span className='glyphicon glyphicon-remove'></span>
                                        </button>
                                        <ButtonDownloadFiles
                                            idUsuario={rowData.id}
                                        />
                                        {/*<BotonEditar
                                            datosbancos = {this.props.datosbancos}
                                            usuario = {rowData}
                                            comunas = {this.props.comunas}
                                            fetchUsuarios = {this.props.fetchUsuarios}
                                            //actualizarUsuario={this.props.actualizarUsuario.bind(rowData.id)}
                                        />
                                        <BotonBloquear
                                            idUsuario = {rowData.id}
                                            estaBloqueado = {rowData.bloqueado}
                                            bloquearUsuario = {this.props.bloquearUsuario}
                                            desbloquearUsuario = {this.props.desbloquearUsuario}
                                        />
                                        <BotonBloquearCliente
                                            usuario = {rowData}
                                            bloquearUsuarioCliente = {this.props.bloquearUsuarioCliente.bind(rowData.id)}
                                            clientes = {this.props.clientes}
                                        />
                                        <BotonCambiarContrasena
                                            idUsuario = {rowData.id}
                                            cambiarContrasena = {this.props.cambiarContrasena}
                                        />
                                        <BotonVerHistorial
                                            idUsuario = {rowData.id}
                                            verHistorial = {this.props.verHistorial.bind(this, rowData.id)}
                                        />
                                        <ButtonUploadFiles
                                            user = {rowData}
                                            idUsuario = {rowData.id}
                                            statusFiles = {rowData.statusFiles}
                                        />
                                        <ButtonDownloadFiles
                                            idUsuario = {rowData.id}
                                        />
                                        <ButtonReviewFiles
                                            user = {rowData}
                                            statusFiles = {rowData.statusFiles}
                                            canApproveFiles = {this.props.perms.canApproveFiles}
                                        />
                                        <ButtonApproveFiles
                                            idUser = {rowData.id}
                                            statusFiles = {rowData.statusFiles}
                                            onApproveFiles = {this.props.onApproveFiles}
                                            canApproveFiles = {this.props.perms.canApproveFiles}
                                />*/}
                                    </div>
                                )}
                                width={360}
                            />
                            {/*<Column
                                dataKey='vigencia'
                                label={'Vigencia'}
                                headerRenderer={()=>
                                    <HeaderConBusqueda
                                        nombre = "Vigencia"
                                        busqueda = {this.props.busquedaVigencia}
                                        realizarBusqueda = {this.props.realizarBusquedaVigencia}
                                    />
                                }
                                cellRenderer={({ dataKey, rowData }) => rowData[dataKey]}
                                width={85}
                            />
                            <Column
                                dataKey='bloqueado'
                                label={'bloqueo'}
                                cellRenderer={({ dataKey, rowData }) => rowData[dataKey]? 'Bloqueado' : ''}
                                width={90}
                            />
                            <Column
                                dataKey='isContractFile'
                                label={'Contrato'}
                                headerRenderer={()=>
                                    <HeaderConBusqueda
                                        nombre = "Contrato"
                                        busqueda = {this.props.seachStatusContract}
                                        realizarBusqueda = {this.props.searchingStatusContract}
                                    />
                                }
                                cellRenderer={({ dataKey, rowData }) => rowData[dataKey]}
                                width={100}
                            />*/}
                        </Table>
                    }
                </AutoSizer>
            </div>
        )
    }
}
TablaPendientes.propTypes = {
    usuarios: PropTypes.arrayOf(PropTypes.object).isRequired,
    // Metodos
    fetchUsuarios: PropTypes.func.isRequired
}

const BotonAprobar = ({ usuario, confirmar, fetchUsuarios }) =>
    <ModalTrigger>
        {(isVisible, showModal, hideModal) =>
            <button className="btn btn-md btn-success" onClick={showModal} title="Aprobar operador">
                <span className={'glyphicon glyphicon-ok'}></span>
                {isVisible && <ModalConfirmar
                    usuario={usuario}
                    confirmar={confirmar}
                    hideModal={hideModal}
                    fetchUsuarios={fetchUsuarios}
                />}
            </button>
        }
    </ModalTrigger>


const ButtonDownloadFiles = ({ idUsuario }) =>
    <a className="btn btn-md btn-primary" title="Descargar documentos de operador"
        href={`/api/usuario/${idUsuario}/download/personal-files`}>
        <span className={'glyphicon glyphicon-download'}></span>
    </a>


// WEBPACK FOOTER //
// ./frontEnd/admin/OperadoresPendientes/TablaPendientes.jsx